// Notification type constants
export const NOTIFICATION_TYPES = {
  CLIENT_MESSAGE: 'client-message',
  ORG_MESSAGE: 'org-message',
  APPOINTMENT_REMINDER: 'appointment-reminder',
  APPOINTMENT_SCHEDULED: 'appointment-scheduled',
  APPOINTMENT_UPDATED: 'appointment-updated',
  TASK_ASSIGNED: 'task-assigned',
  TASK_DUE: 'task-due',
  LAB_RESULT: 'lab-result-ready',
  CLIENT_DOCUMENT: 'client-document-uploaded',
  TICKET_ACKNOWLEDGED: 'ticket-acknowledged',
  TICKET_RESOLVED: 'ticket-resolved',
  SUPPORT_TICKET_COMMENT: 'support-ticket-comment'
};

// Notification handlers for each type - defines display properties
export const notificationHandlers = {
  [NOTIFICATION_TYPES.APPOINTMENT_SCHEDULED]: () => ({
    icon: '📅',
    color: 'green',
    navigateTo: '/client/appointments',
    sound: true
  }),
  [NOTIFICATION_TYPES.CLIENT_MESSAGE]: (data) => ({
    icon: '💬',
    color: 'blue',
    navigateTo: `/midwife/messages?tab=clients&conversation=${data.conversationId}`,
    sound: true
  }),
  [NOTIFICATION_TYPES.ORG_MESSAGE]: (data) => ({
    icon: '👥',
    color: 'purple',
    navigateTo: `/midwife/messages?tab=organization&conversation=${data.conversationId}`,
    sound: true
  }),
  [NOTIFICATION_TYPES.APPOINTMENT_REMINDER]: (data) => ({
    icon: '📅',
    color: 'green',
    navigateTo: `/appointments/${data.appointmentId}`,
    sound: true
  }),
  [NOTIFICATION_TYPES.APPOINTMENT_UPDATED]: (data) => ({
    icon: '📅',
    color: 'amber',
    navigateTo: `/appointments/${data.appointmentId}`,
    sound: true
  }),
  [NOTIFICATION_TYPES.TASK_ASSIGNED]: (data) => ({
    icon: '✓',
    color: 'indigo',
    navigateTo: `/midwife/tasks?task=${data.taskId || data.entityId || ''}`,
    sound: true
  }),
  [NOTIFICATION_TYPES.TASK_DUE]: (data) => ({
    icon: '⚠️',
    color: 'red',
    navigateTo: `/midwife/tasks?task=${data.taskId || data.entityId || ''}`,
    sound: true
  }),
  [NOTIFICATION_TYPES.LAB_RESULT]: (data) => ({
    icon: '🔬',
    color: 'teal',
    navigateTo: `/clients/${data.clientId}/labs`,
    sound: true
  }),
  [NOTIFICATION_TYPES.CLIENT_DOCUMENT]: (data) => ({
    icon: '📄',
    color: 'slate',
    navigateTo: `/clients/${data.clientId}/documents`,
    sound: false
  }),
  [NOTIFICATION_TYPES.TICKET_ACKNOWLEDGED]: () => ({
    icon: '🎫',
    color: 'blue',
    navigateTo: '/midwife/tickets',
    sound: false
  }),
  [NOTIFICATION_TYPES.TICKET_RESOLVED]: () => ({
    icon: '✅',
    color: 'green',
    navigateTo: '/midwife/tickets',
    sound: false
  }),
  [NOTIFICATION_TYPES.SUPPORT_TICKET_COMMENT]: (data) => ({
    icon: '💬',
    color: 'blue',
    navigateTo: data.url || `/support/tickets/${data.entityId}`,
    sound: false
  })
};

// Get notification configuration by type
export function getNotificationConfig(type, data = {}) {
  const handler = notificationHandlers[type];
  if (typeof handler === 'function') {
    return handler(data);
  }
  return handler || {
    icon: '🔔',
    color: 'gray',
    navigateTo: '/',
    sound: false
  };
}

// Format notification for display
export function formatNotification(notificationData) {
  const payload = notificationData.data || notificationData;
  const config = getNotificationConfig(notificationData.type, payload);
  const explicitNavigateTo = payload.url || notificationData.navigateTo;
  
  return {
    ...notificationData,
    ...config,
    navigateTo: explicitNavigateTo || config.navigateTo,
    id: notificationData.id || `notif-${Date.now()}`,
    timestamp: notificationData.timestamp || new Date().toISOString(),
    read: notificationData.read || false
  };
}
